import { useEffect, useState } from "react";
import { axios } from "helper/axios";
import { parsePromoAds } from "utils/parsePromoAd";

const ADS_API = "dashboard/ads";

export const usePromoAd = () => {
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        setLoading(true);
        const response = await axios.get(ADS_API, {
          skipErrorToast: true,
        });

        if (!cancelled) {
          setAds(parsePromoAds(response));
        }
      } catch (error) {
        console.error("Failed to load dashboard ads:", error);
        if (!cancelled) {
          setAds([]);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, []);

  return {
    ads,
    /** @deprecated Prefer `ads` — kept for single-ad call sites */
    promoAd: ads[0] || null,
    loading,
  };
};

export default usePromoAd;
